import { render } from "./BoardDetailPage.vue?vue&type=template&id=7ad88c8c&scoped=true"
import script from "./BoardDetailPage.vue?vue&type=script&lang=js"
export * from "./BoardDetailPage.vue?vue&type=script&lang=js"

import "./BoardDetailPage.vue?vue&type=style&index=0&id=7ad88c8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ad88c8c"]])

export default __exports__